import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ApButtonComponent } from '@ap/button';
import { ApContentModule } from '@ap/content';

import { MijnStartChatComponent } from './mijn-start-chat.component';

@NgModule({
    imports: [ApButtonComponent, ApContentModule, CommonModule],
    declarations: [MijnStartChatComponent],
    exports: [MijnStartChatComponent]
})
export class MijnStartChatModule {}
